export default __webpack_public_path__ + "static/media/auth-bg.d658580c.jpg";